import useOptionSources from 'hooks/useOptionSources'

export function useOriginsList() {
    const optionSources = useOptionSources()
    return optionSources?.origins || []
}
